module.exports = __webpack_public_path__ + "static/media/smart_driver.9dec8c52.png";